import React from "react";
import { FileText, FileArchive } from "lucide-react";

export type PayslipUploadMode = "pdf" | "zip";

interface Option {
  id: PayslipUploadMode;
  label: string;
  sub: string;
  icon: React.ReactNode;
}

const OPTIONS: Option[] = [
  {
    id: "pdf",
    label: "Single PDF",
    sub: "One file containing many payslips",
    icon: <FileText size={16} />,
  },
  {
    id: "zip",
    label: "ZIP archive",
    sub: "One PDF per employee",
    icon: <FileArchive size={16} />,
  },
];

interface Props {
  value: PayslipUploadMode;
  onChange: (next: PayslipUploadMode) => void;
  disabled?: boolean;
}

const PayslipUploadModeToggle: React.FC<Props> = ({
  value,
  onChange,
  disabled,
}) => (
  <div
    role="group"
    aria-label="Upload type"
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 6,
      padding: 4,
      background: "#f3f3f3",
      borderRadius: 12,
      opacity: disabled ? 0.55 : 1,
      pointerEvents: disabled ? "none" : "auto",
    }}
  >
    {OPTIONS.map((option) => {
      const active = option.id === value;
      return (
        <button
          type="button"
          key={option.id}
          aria-pressed={active}
          aria-disabled={disabled}
          disabled={disabled}
          onClick={() => {
            if (disabled) return;
            onChange(option.id);
          }}
          style={{
            padding: "10px 12px",
            borderRadius: 8,
            background: active ? "#ffffff" : "transparent",
            boxShadow: active ? "0 1px 2px rgba(6,33,51,0.08)" : "none",
            cursor: disabled ? "not-allowed" : "pointer",
            border: "none",
            textAlign: "left",
            display: "flex",
            gap: 10,
            alignItems: "flex-start",
            transition: "background 120ms",
          }}
        >
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 6,
              background: active ? "#fff0f2" : "transparent",
              color: active ? "#ff697f" : "#6a7a85",
              display: "grid",
              placeItems: "center",
              flexShrink: 0,
            }}
          >
            {option.icon}
          </div>
          <div>
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: active ? "#062133" : "#6a7a85",
              }}
            >
              {option.label}
            </div>
            <div
              style={{
                fontSize: 11,
                color: "#6a7a85",
                marginTop: 1,
                lineHeight: "14px",
              }}
            >
              {option.sub}
            </div>
          </div>
        </button>
      );
    })}
  </div>
);

export default PayslipUploadModeToggle;
